export default "__VITE_ASSET__BZcr$y1o__"